import { render, staticRenderFns } from "./AppTopbarLink.vue?vue&type=template&id=c3e9556a&"
import script from "./AppTopbarLink.vue?vue&type=script&lang=js&"
export * from "./AppTopbarLink.vue?vue&type=script&lang=js&"
import style0 from "./AppTopbarLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports